// Author Eric
// Date 2020-10-02 11:53:39

import * as model from "@/model/sithMes/andon/SithMesAndonTypePositionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesAndonTypePosition(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_ANDON_URL,
    })
    .buildStore()
